import BaseService from "./BaseService";
import http from "./HttpService";
import { API_BASE_URL_ENV } from "../jsx/common/common";

const apiEndpoint = API_BASE_URL_ENV() + "/role/adminRole";
const apiGetModuleEndpoint = API_BASE_URL_ENV() + "/role/module";
const apiFindModuleEndpoint = API_BASE_URL_ENV() + "/role/rolePermission";

export default class RoleService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}

	getModule = () => {
		return http.get(apiGetModuleEndpoint);
	};

	find(id) {
		return http.get(`${apiFindModuleEndpoint}/${id}`);
	}
}
